import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { useNavigate, useLocation } from 'react-router-dom';
import './BrandsCarousel.css';

// Dynamically import all images from the assets/images folder
const importAllImages = requireContext =>
  requireContext.keys().map(requireContext);

const images = importAllImages(
  require.context(
    '../../assets/images/brand-carousel',
    false,
    /\.(png|jpe?g|svg)$/
  )
);

const CarouselComponent = ({ disabled = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const trackRef = useRef(null);

  // Check if we're on the international page
  const isInternationalPage = location.pathname === '/international';

  // Logos to hide on international page
  const logosToHideOnInternational = [
    'Capitec Logo.png',
    'Mr D Logo.png',
    'Rainmaker Logo.png',
    'Takealot Logo.png',
  ];

  // Filter images based on current page
  const filteredImages = isInternationalPage
    ? images.filter(image => {
        const imageName = image.split('/').pop(); // Get filename from path

        // Extract base filename before hash (e.g., "Mr D Logo.2a82e94d3b51e87ad0ec.png" -> "Mr D Logo.png")
        const baseFileName = imageName.replace(/\.[a-f0-9]{20,}\.png$/, '.png');

        const shouldHide = logosToHideOnInternational.includes(baseFileName);
        return !shouldHide;
      })
    : images;

  const handleConnectClick = () => {
    if (!disabled) {
      navigate('/lets-talk');
    }
  };

  useEffect(() => {
    if (trackRef.current) {
      // Calculate the width of one complete set of images
      const firstSet = trackRef.current.querySelector('.carousel-set');
      if (firstSet) {
        const singleSetWidth = firstSet.getBoundingClientRect().width;
        const scrollSpeed = 30; // Slower speed for smoother effect
        const duration = singleSetWidth / scrollSpeed;

        // Set CSS custom property for animation duration
        trackRef.current.style.setProperty(
          '--animation-duration',
          `${duration}s`
        );
        trackRef.current.style.setProperty(
          '--set-width',
          `${singleSetWidth}px`
        );
      }
    }
  }, []);

  // Create enough duplicates to ensure no gaps
  const createImageSets = () => {
    const sets = [];
    for (let setIndex = 0; setIndex < 4; setIndex++) {
      sets.push(
        <div key={`set-${setIndex}`} className="carousel-set">
          {filteredImages.map((image, index) => (
            <div key={`set${setIndex}-${index}`} className="carousel-item">
              <img
                alt={`Brand ${index + 1}`}
                src={image}
                className="logo-image"
              />
            </div>
          ))}
        </div>
      );
    }
    return sets;
  };

  return (
    <motion.div
      className="brands-carousel-section"
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        duration: 0.8,
        ease: 'easeOut',
      }}
    >
      <div className="carousel-container">
        <div className="carousel-track" ref={trackRef}>
          {createImageSets()}
        </div>
      </div>

      {!disabled && (
        <div className="connect-button-container-home">
          <button onClick={handleConnectClick} className="connect-button-home">
            REQUEST ACCESS
          </button>
        </div>
      )}
    </motion.div>
  );
};

export default CarouselComponent;
